var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlightTaskTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 7.65h9.8c.27 0 .49-.22.49-.49V5.2a.49.49 0 00-.49-.49h-.49v-.49c0-.81-.66-1.47-1.47-1.47h-5.88c-.81 0-1.47.66-1.47 1.47v.49h-.49a.49.49 0 00-.49.49v1.96c0 .27.22.49.49.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 5.69h-1.56c.06.16.09.32.09.49v.98c0 .81-.66 1.47-1.47 1.47h-9.8c-.81 0-1.47-.66-1.47-1.47v-.98c0-.17.03-.33.09-.49H7.16c-.81 0-1.47.66-1.47 1.47v18.62c0 .81.66 1.47 1.47 1.47h15.68c.81 0 1.47-.66 1.47-1.47V7.16c0-.81-.66-1.47-1.47-1.47zm-3.39 9.83l-4.9 4.9c-.14.14-.33.22-.52.22-.17 0-.33-.06-.47-.17l-2.94-2.45a.743.743 0 01-.1-1.04c.26-.32.73-.36 1.04-.09l2.42 2.02 4.42-4.42a.74.74 0 011.04.01c.28.27.28.73.01 1.02z"
  })));
}

export default SvgHighlightTaskTick;